<template>
  <v-container fluid>
    <v-toolbar flat color="blue-grey lighten-4">
      <span class="font-weight-medium">ประเภทบัตร</span>
      <v-scroll-x-transition>
        <v-row align="center" v-show="!cardTypeFormShow">
          <v-spacer></v-spacer>
          <v-col md="3" lg="3" xl="2" class="pr-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="ค้นหา"
              clearable
              flat
              solo
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col md="3" lg="3" xl="2">
            <div
              style="
                background-color: white;
                padding: 3px 10px 7px 10px;
                border-radius: 4px;
              "
            >
              <v-checkbox
                v-model="filterDefaultCard"
                label="ค่าเริ่มต้นบัตร"
                dense
                hide-details
              ></v-checkbox>
            </div>
          </v-col>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card_type:create')"
            color="primary"
            @click="handleAddCardTypeForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มประเภทบัตร
          </v-btn>
          <!-- <v-menu min-width="200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list nav dense>
              <v-list-item link @click="uploadDialog = true">
                <v-list-item-icon>
                  <v-icon>mdi-import</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>นำเข้าข้อมูล</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </v-row>
      </v-scroll-x-transition>
    </v-toolbar>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="cardTypes"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.is_default_for_employee_card="{ item }">
        <v-icon v-if="item.is_default_for_employee_card" small color="success">
          mdi-check
        </v-icon>
        <div v-else>-</div>
      </template>
    </v-data-table>
    <CardTypeForm
      :formShow="cardTypeFormShow"
      :formAction="cardTypeFormAction"
      :cardType="cardType"
      :cardTypeInit="cardTypeInit"
      @isCardTypeDataChange="handleCardTypeFormDataChange"
      @formActionCompleted="handleCardTypeFormActionCompleted"
      @onReset="handleCardTypeFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="cardTypeFormShow && cardTypeFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <UploadDialog
      :uploadDialog="uploadDialog"
      uploadDialogTitle="นำเข้าข้อมูลประเภทบัตร"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      downloadExampleFileImportDataName="card-type.csv"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadMessageDialog
      :uploadMessageDialog="uploadMessageDialog"
      :uploadFail="uploadFail"
      @handleCloseUploadMessageDialog="handleCloseUploadMessageDialog"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import UploadDialog from '@/components/UploadDialog.vue'
import UploadMessageDialog from '@/components/UploadMessageDialog.vue'
import CardTypeForm from '@/views/card-type/CardTypeForm.vue'

export default {
  components: {
    CardTypeForm,
    ConfirmDialog,
    UploadDialog,
    UploadMessageDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      filterDefaultCard: false,
      sortBy: ['card_type_code'],
      sortDesc: [false],
      currentFile: null,
      uploadDialog: false,
      uploadMessageDialog: false,
      uploadFail: [],
      uploadMessageDialogTimeout: null,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      cardTypeFormShow: false,
      cardTypeFormAction: '',
      isCardTypeDataChange: false,
      cardType: {},
      cardTypeInit: {},
      timeout: null,
      headers: [
        { text: 'รหัส', value: 'card_type_code' },
        { text: 'ประเภทบัตร (ไทย)', value: 'title_th' },
        {
          text: 'ประเภทบัตร (อังกฤษ)',
          value: 'title_en',
        },
        {
          text: 'ค่าเริ่มต้นบัตรพนักงาน',
          value: 'is_default_for_employee_card',
          filter: (value) => {
            if (!this.filterDefaultCard) return true
            return value
          },
          width: '170',
        },
      ],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    cardTypes() {
      return this.$store.state.card.cardTypes
    },
    exampleFileImportDataUrl() {
      return this.$store.state.download.exampleFileImportDataUrl
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ประเภทบัตร',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchCardTypes: 'card/fetchCardTypes',
      uploadFileImportData: 'upload/uploadFileImportData',
      downloadExampleFileImportData: 'download/downloadExampleFileImportData',
    }),
    handleCloseUploadMessageDialog() {
      this.uploadMessageDialog = false
    },
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          uuid: company_uuid,
          fileType: 'card',
          formData: formData,
        }

        this.$store.state.loading = true

        this.uploadFileImportData(payload)
          .then(({ result, total_fail }) => {
            this.$store.state.loading = false

            this.loadData()
            this.uploadDialog = false
            refs.clearableCallback()

            if (total_fail > 0) {
              this.uploadMessageDialogTimeout = setTimeout(() => {
                this.uploadMessageDialog = true
                this.uploadFail = result.result_fail
              }, 200)
            } else {
              const snackbar = {
                show: true,
                color: 'success',
                timeout: 2000,
                message: 'นำเข้าข้อมูลสำเร็จ',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
            }
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.uploadDialog = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    classRowSelected(row) {
      if (this.cardType.card_type_uuid === row.card_type_uuid) {
        return 'row-selected'
      }
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::card_type:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.cardType.card_type_uuid === row.card_type_uuid) {
        this.cardTypeFormShow = false
        this.cardTypeFormAction = ''
        this.cardType = {}
        this.cardTypeInit = {}
      } else {
        this.cardTypeFormShow = true
        this.cardTypeFormAction = 'edit'
        this.cardType = { ...row }
        this.cardTypeInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isCardTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddCardTypeForm() {
      this.cardTypeFormShow = true
      this.cardTypeFormAction = 'add'
      this.cardType = {}
      this.cardTypeInit = {}
    },
    handleCardTypeFormDataChange(value) {
      this.isCardTypeDataChange = value
    },
    handleCardTypeFormReset(formAction) {
      // if (formAction === 'edit') this.cardType = { ...this.cardTypeInit }
      this.cardTypeFormAction = ''
      this.cardTypeFormShow = false
      this.cardType = {}
      this.cardTypeInit = {}
    },
    handleCardTypeFormActionCompleted(formAction) {
      this.cardType = {}
      this.cardTypeInit = {}
      this.cardTypeFormShow = false
      this.cardTypeFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      Promise.all([this.fetchCardTypes({ company_uuid })])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.cardTypeFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCardTypeDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    clearTimeout(this.uploadMessageDialogTimeout)
  },
}
</script>
